const viewRelatedProductComponent = (data) => {
  const mappedData = {
    'display': data.field_product_display[0]?.value,
    'views-sort': {
      'id': 'sort-by',
      'value': data.field_order_by[0]?.value
    },
    'views-filter': {
      'id': 'field_product_category_target_id',
      'value': data.field_product_category[0]?.name[0]?.value
    },
    'title': data.field_title[0].value
  };
  return mappedData;
};

export default viewRelatedProductComponent;
